module.exports = __webpack_public_path__ + "img/TSANet-Connect-Logo_registered_trademark.203fd606.png";